<template>
    <validation-observer v-slot="{ invalid }" ref="form">
        <!-- 验证是否需要油卡 -->
        <validation-provider
            :rules="`${!isIphone ? 'required' : ''}`"
            :customMessages="{required:'请点击上方添加油卡'}"
        >
            <input type="hidden" v-model="listId" />
            <!-- 验证选中商品 -->
        </validation-provider>
        <validation-provider rules="required" :customMessages="{required:'请选择充值金额'}">
            <input type="hidden" v-model="goodId" />
        </validation-provider>
        <div class="priceWrap bh bstart bwrap correct-list">
            <div
                class="priceItem list-item"
                v-for="(item,index) in data"
                :key="index"
                @click="changePrice(item.id)"
                :class="{'correct-active' : goodId == item.id}"
            >
                <div class="item">
                    <div class="item-el item-oil bv bc">
                        <p class="fz_34">{{item.price}}元</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="phoneWrap">
            <validation-provider name="手机号码" rules="required|mobile" v-slot="{ errors }">
                <van-field
                    clearable
                    label="手机号码"
                    type="tel"
                    maxlength="11"
                    v-model="telephone"
                    placeholder="请输入手机号"
                >
                    <zb-warning slot="right-icon" :message="errors[0]" />
                </van-field>
            </validation-provider>
        </div>
        <div class="xBtn-wrap">
            <van-button
                size="large"
                @click="onBuyClick"
                class="logBtn btn btn-submit-big"
                :class="getBtnCls(invalid)"
            >立即充值</van-button>
        </div>
    </validation-observer>
</template>
<script>
import { oilPriceList } from "@/api/fee";
import { mixinValid } from "@/mixin/valid";
export default {
    mixins: [mixinValid],
    props: {
        typeId: {
            type: Number
        },
        typeName: {
            type: String
        },
        listId: {
            type: String
        }
    },
    computed: {
        // 是否卡密模式
        isIphone() {
            return this.typeName == "卡密";
        }
    },
    data() {
        return {
            telephone: "",
            goodId: "",
            data: []
        };
    },
    methods: {
        changePrice(id) {
            this.goodId = id;
        },
        // 确认充值
        onBuyClick() {
            const me = this;
            me.validForm().then(() => {
                me.$emit(
                    "buy",
                    me.goodId,
                    me.listId,
                    me.telephone,
                    me.isIphone
                );
            });
        }
    },
    created() {
        const me = this;
        // 测试环境处理
        if (me.$store.state.isDev) {
            me.telephone = "18784012064";
        }
        oilPriceList(me.typeId).then(res => {
            this.data = res.data;
        });
    }
};
</script>

<style scoped lang="scss">
.priceWrap {
    padding: 40px 40px 20px 40px;
    .priceItem {
        width: 31%;
        margin-bottom: 24px;
        &:not(:nth-child(3n)) {
            margin-right: 20px;
        }
        .item-oil {
            height: 120px;
        }
    }
}
.phoneWrap {
    padding: 0 30px 60px;
    /deep/ .van-cell {
        width: 690px;
        border: 1px solid #dcdcdc;
        border-radius: 10px;
        padding: 30px 25px;
    }
}
.xBtn-wrap {
    padding: 0 120px 60px;
}
</style>